var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1C27.944 1 34 6.993 34 14.36c0 2.414-.658 4.781-1.904 6.844L21.653 38.459a1.132 1.132 0 01-1.921.015L9.015 21.384A13.228 13.228 0 017 14.36C7 6.993 13.056 1 20.5 1zm0 2.212c-6.203 0-11.265 5.009-11.265 11.147 0 2.075.595 4.098 1.693 5.852l9.742 15.537 9.495-15.687a11.036 11.036 0 001.593-5.702c0-6.138-5.055-11.147-11.258-11.147zM20.5 7c4.136 0 7.5 2.916 7.5 6.5 0 3.522-3.258 6.5-7.5 6.5-4.19 0-7.5-2.939-7.5-6.5C13 9.916 16.364 7 20.5 7zm0 2.152c-2.757 0-5.017 1.959-5.017 4.348 0 2.395 2.246 4.348 5.017 4.348 2.815 0 5.008-1.988 5.008-4.348 0-2.39-2.251-4.348-5.008-4.348z",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.3a429af6e94982020d2e65ef0de7eff7.svg";
export { ForwardRef as ReactComponent };